import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import api from '../../axiosConfig';
import Modal from 'bootstrap/js/dist/modal';
import AsyncSelect from 'react-select/async';
import { v4 as uuidv4 } from "uuid";
import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';
import DOMPurify from 'dompurify';


export default function TablaNotificaciones() {
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    const [editingUser, setEditingUser] = useState(null);
    const [selectedEmpleado, setSelectedEmpleado] = useState([]);
    const [selectedTipo, setSelectedTipo] = useState(null);

    const [selectedMarca, setSelectedMarca] = useState([]);
    const [selectedArea, setSelectedArea] = useState([]);

    // opciones precargadas al abrir (para mostrar al click sin teclear)
    const [tipoDefaultOptions, setTipoDefaultOptions] = useState([]);
    const [empleadoDefaultOptions, setEmpleadoDefaultOptions] = useState([]);
    const [marcaDefaultOptions, setMarcaDefaultOptions] = useState([]);
    const [areaDefaultOptions, setAreaDefaultOptions] = useState([]);

    const [formFecha, setFormFecha] = useState('');
    const [formTitulo, setFormTitulo] = useState('');
    const [formEnlace, setFormEnlace] = useState('');

    // …dentro del componente del modal…
    const [mensajeHtml, setMensajeHtml] = useState('');

    useEffect(() => {
        // Si ya tenías valor por defecto (texto o HTML), precárgalo
        const initial = getValue('mensaje') || '';
        setMensajeHtml(initial);
    }, [/* si cambia el registro */]);

    useEffect(() => {
        setMensajeHtml(editingUser?.mensaje ?? '');

        setFormFecha(editingUser?.fecha ?? '');
        setFormTitulo(editingUser?.titulo ?? '');
        setFormEnlace(editingUser?.enlace ?? '');
    }, [editingUser]);

    // Sanitiza HTML de salida (XSS-safe)
    const sanitize = (html) => DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });

    // Opcional: validación requerida (sin contar etiquetas)
    const isMensajeVacio = useMemo(() => {
        const tmp = document.createElement('div');
        tmp.innerHTML = mensajeHtml || '';
        return (tmp.textContent || '').trim().length === 0;
    }, [mensajeHtml]);

    // Toolbar mínima (ajústala a tu gusto)
    const quillModules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ align: [] }],
            ['link', 'clean'],
        ],
    };

    const quillFormats = [
        'header',
        'bold', 'italic', 'underline', 'strike',
        'list', 'bullet',
        'align',
        'link',
    ];

    useEffect(() => {
        getDatos();
    }, [page, limit, search]);

    function generateFileName(originalName) {
        const ext = originalName.split(".").pop().toLowerCase(); // extensión original
        const id = uuidv4();
        return `${id}.${ext}`;
    }


    // === Helpers ===
    const VALID_TYPES = ["image/png", "image/jpeg"];
    const MAX_SIZE = 3 * 1024 * 1024; // 3MB

    function validateFile(file) {
        if (!file) return { ok: false, msg: "Selecciona una imagen." };
        if (!VALID_TYPES.includes(file.type)) return { ok: false, msg: "Solo PNG o JPEG." };
        if (file.size > MAX_SIZE) return { ok: false, msg: "El archivo no debe pesar más de 3 MB." };
        return { ok: true };
    }

    /** Convierte File a Base64.
 *  Retorna: { dataUrl, base64, mime }
 */
    function fileToBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onerror = () => reject(new Error("No se pudo leer el archivo."));
            reader.onload = () => {
                const dataUrl = reader.result; // "data:image/png;base64,AAAA..."
                const [header, b64] = String(dataUrl).split(",");
                const mime = header.substring(header.indexOf(":") + 1, header.indexOf(";"));
                resolve({ dataUrl, base64: b64, mime });
            };
            reader.readAsDataURL(file);
        });
    }


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validar tipo
        const validTypes = ["image/png", "image/jpeg"];
        if (!validTypes.includes(file.type)) {
            alert("Solo se permiten imágenes PNG o JPEG.");
            e.target.value = ""; // reset input
            return;
        }

        // Validar tamaño (máx. 3MB)
        const maxSize = 3 * 1024 * 1024; // 3 MB en bytes
        if (file.size > maxSize) {
            alert("El archivo no debe pesar más de 3 MB.");
            e.target.value = "";
            return;
        }

        // Generar nombre nuevo
        const newName = generateFileName(file.name);
        console.log("Nuevo nombre:", newName);
        // Aquí podrías subir el archivo con ese nombre al backend/S3
    };

    const getDatos = async () => {
        try {
            const res = await api.get(`/notificaciones/table?inicio=${(page - 1) * limit}&longitud=${limit}&orden=desc&ordenColumn=id_notificacion&cadena=${encodeURIComponent(search)}`);
            setData(res.data.data);
            //setTotal(res.data.recordsTotal);
            setTotal(res.data.recordsFiltered);
        } catch (err) {
            console.error("Error al obtener datos:", err);
        }
    };

    function formatearFechaLarga(fechaIso) {
        try {
            const fecha = new Date(fechaIso);
            const opciones = { day: '2-digit', month: 'long', year: 'numeric' };
            const formateada = new Intl.DateTimeFormat('es-ES', opciones).format(fecha);
            return formateada.charAt(0).toUpperCase() + formateada.slice(1);
        } catch (err) {
            return ''
        }
    }

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
        setPage(1);
    };

    const handleDelete = async (row) => {
        if (!window.confirm(`¿Estás seguro que deseas eliminar la notificación "${row.titulo}"?`)) return;
        await api.delete(`/notificaciones/${row.idNotificacion}`);
        getDatos();
    };

    const handleEdit = (row) => {
        setEditingUser(row);

        // set tipo seleccionado
        console.log(row)
        setSelectedTipo(row?.idTipoNotificacion
            ? {
                label: row.idTipoNotificacion.tipo,
                value: row.idTipoNotificacion.idTipoNotificacion,
                data: null
            }
            : null
        );

        // map trabajadores (notificacionesDetList → usuarios)
        if (Array.isArray(row?.notificacionesDetList) && row.notificacionesDetList.length) {
            const mapped = row.notificacionesDetList
                .filter(d => d?.idUsuario)
                .map(d => ({
                    label: d.idUsuario.rfc,
                    value: String(d.idUsuario.idUsuario),
                    data: d.idUsuario
                }));
            setSelectedEmpleado(mapped);
        } else {
            setSelectedEmpleado([]);
        }


        // map trabajadores (notificacionesDetList → usuarios)
        if (Array.isArray(row?.notificacionesGruposList) && row.notificacionesGruposList.length) {
            const mapped = row.notificacionesGruposList
                .filter(d => d?.cve)
                .map(d => ({
                    label: d.cve,
                    value: String(d.cve),
                    data: null
                }));

            switch (row.idTipoNotificacion.idTipoNotificacion) {
                case 3:
                    setSelectedMarca(mapped);
                    break
                case 4:
                    setSelectedArea(mapped);
                    break
            }


        } else {
            setSelectedArea([]);
            setSelectedMarca([])
        }


        setMensajeHtml(row.mensaje);

        const modal = new Modal(document.getElementById('exampleModal'));
        modal.show();
    };

    const totalPages = Math.ceil(total / limit);
    const getValue = (key, fallback = '') => editingUser?.[key] ?? fallback;

    // --------- Select: cargar al teclear ----------
    const loadEmpleados = async (inputValue) => {
        try {
            const res = await api.get(`/usuarios/select2?cadena=${encodeURIComponent(inputValue || '')}&pagina=1`);
            return (res.data?.results || []).map(emp => ({
                label: emp.text,
                value: String(emp.id),
                data: emp
            }));
        } catch (err) {
            console.error("Error al cargar empleados:", err);
            return [];
        }
    };

    const loadTipo = async (inputValue) => {
        try {
            // Si tienes endpoint real, descomenta:
            // const res = await api.get(`/notificaciones/tipos/select2?cadena=${encodeURIComponent(inputValue || '')}&pagina=1`);
            // return (res.data?.results || []).map(t => ({ label: t.text, value: t.id, data: t }));

            // Mock de ejemplo:
            const base = [
                { label: "General", value: 1, data: null },
                { label: "Directa", value: 2, data: null },
                { label: "Marca", value: 3, data: null },
                { label: "Area", value: 4, data: null }
            ];
            if (!inputValue) return base;
            const q = inputValue.toLowerCase();
            return base.filter(o => o.label.toLowerCase().includes(q));
        } catch (err) {
            console.error("Error al cargar tipos:", err);
            return [];
        }
    };


    const loadMarcas = async (inputValue) => {
        try {
            // Si tienes endpoint real, descomenta:
            const res = await api.get(`/empleados/marcas/select2?cadena=${encodeURIComponent(inputValue || '')}&pagina=1`);
            return (res.data?.results || []).map(t => ({ label: t.text, value: t.id, data: t }));


        } catch (err) {
            console.error("Error al cargar tipos:", err);
            return [];
        }
    };


    const loadAreas = async (inputValue) => {
        try {
            // Si tienes endpoint real, descomenta:
            const res = await api.get(`/empleados/areas/select2?cadena=${encodeURIComponent(inputValue || '')}&pagina=1`);
            return (res.data?.results || []).map(t => ({ label: t.text, value: t.id, data: t }));


        } catch (err) {
            console.error("Error al cargar tipos:", err);
            return [];
        }
    };

    const prefetchMarcas = async () => {
        try {
            const opts = await loadMarcas('');
            setMarcaDefaultOptions(opts);
        } catch {
            setMarcaDefaultOptions([]);
        }
    };

    const prefetchAreas = async () => {
        try {
            const opts = await loadAreas('');
            setAreaDefaultOptions(opts);
        } catch {
            setAreaDefaultOptions([]);
        }
    };

    // --------- Prefetch al abrir el menú (click) para mostrar opciones sin teclear ----------
    const prefetchTipos = async () => {
        try {
            const opts = await loadTipo('');
            setTipoDefaultOptions(opts);
        } catch {
            setTipoDefaultOptions([]);
        }
    };

    const prefetchEmpleados = async () => {
        try {
            const opts = await loadEmpleados('');
            setEmpleadoDefaultOptions(opts);
        } catch {
            setEmpleadoDefaultOptions([]);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isMensajeVacio) return;


        // Toma el File real
        const fileInput = e.target.elements["imagen"];
        const file = fileInput?.files?.[0] || null;

        // Si hay archivo, valida y prepara nombre/base64
        let uuidNombre = null;
        let archivoBase64 = null;
        let mimeType = null;

        if (file) {
            const v = validateFile(file);
            if (!v.ok) { alert(v.msg); return; }

            uuidNombre = generateFileName(file.name);
            const { base64, mime } = await fileToBase64(file);
            archivoBase64 = base64;
            mimeType = mime;
        }

        const payload = {
            titulo: formTitulo,
            mensaje: sanitize(mensajeHtml),
            fecha: formFecha,
            enlace: formEnlace,
            uuid: uuidNombre,
            archivo: archivoBase64,
            mimeType,
            idTipoNotificacion: {
                idTipoNotificacion: selectedTipo?.value
            },
            notificacionesDetList: (selectedTipo?.value === 2 ? selectedEmpleado : [])
                .map(opt => ({
                    idUsuario: { idUsuario: opt.value }
                })),
            notificacionesGruposList: (
                selectedTipo?.value === 3
                    ? selectedMarca
                    : selectedTipo?.value === 4
                        ? selectedArea
                        : []
            ).map(opt => ({
                cve: opt.value
            }))
        };

        try {
            if (editingUser) {
                await api.put(`/notificaciones/${editingUser.idNotificacion}`, payload);
            } else {
                await api.post(`/notificaciones`, payload);
            }
            getDatos();
            const modal = Modal.getInstance(document.getElementById('exampleModal'));
            modal?.hide();
        } catch (err) {
            console.error("Error al guardar notificación:", err);
        }
    };

    const renderFooter = () => {
        return (
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                <span>Mostrando {data.length} de {total} Registros</span>
                <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                    {/* Botón anterior */}
                    <li className="page-item">
                        <button
                            className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                            onClick={() => page > 1 && setPage(page - 1)}
                            disabled={page === 1}
                        >
                            <Icon icon="ep:d-arrow-left" />
                        </button>
                    </li>

                    {/* Calcular rango de páginas */}
                    {(() => {
                        const pagesToShow = 5;
                        let startPage = Math.max(1, page - Math.floor(pagesToShow / 2));
                        let endPage = startPage + pagesToShow - 1;

                        if (endPage > totalPages) {
                            endPage = totalPages;
                            startPage = Math.max(1, endPage - pagesToShow + 1);
                        }

                        const pageNumbers = [];
                        for (let i = startPage; i <= endPage; i++) {
                            pageNumbers.push(i);
                        }

                        return pageNumbers.map((num) => (
                            <li className="page-item" key={num}>
                                <button
                                    className={`page-link fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md ${page === num
                                        ? "bg-primary-600 text-white"
                                        : "bg-neutral-200 text-secondary-light"
                                        }`}
                                    onClick={() => setPage(num)}
                                >
                                    {num}
                                </button>
                            </li>
                        ));
                    })()}

                    {/* Botón siguiente */}
                    <li className="page-item">
                        <button
                            className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                            onClick={() => page < totalPages && setPage(page + 1)}
                            disabled={page === totalPages}
                        >
                            <Icon icon="ep:d-arrow-right" />
                        </button>
                    </li>
                </ul>
            </div>
        )
    }


    return (
        <>
            <div className="card h-100 p-0 radius-12">
                <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                    <div className="d-flex align-items-center flex-wrap gap-3">
                        <span className="text-md fw-medium text-secondary-light mb-0">Mostrar</span>
                        <select
                            className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                            value={limit}
                            onChange={(e) => setLimit(parseInt(e.target.value))}
                        >
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                        </select>
                        <form className="navbar-search">
                            <input
                                type="text"
                                className="bg-neutra h-40-px w-auto"
                                name="search"
                                placeholder="Buscar"
                                value={search}
                                onChange={handleSearchChange}
                            />
                            <Icon icon="ion:search-outline" className="icon" />
                        </form>
                    </div>
                    <button
                        type="button"
                        className="btn btn-primary-600 text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
                        onClick={() => {
                            setEditingUser(null);
                            setSelectedTipo(null);
                            setSelectedEmpleado([]);
                            setSelectedArea([]);
                            setSelectedMarca([])
                            setMensajeHtml("");

                            setFormFecha('');
                            setFormTitulo('');
                            setFormEnlace('');

                            const modal = new Modal(document.getElementById('exampleModal'));
                            modal.show();
                        }}
                    >
                        <Icon icon="ic:baseline-plus" className="icon text-xl line-height-1" />
                        Nueva notificación
                    </button>
                </div>

                <div className="card-body p-24">
                    <div className="table-responsive scroll-sm">
                        <table className="table bordered-table sm-table mb-0">
                            <thead>
                                <tr>
                                    <th scope="col">Id</th>
                                    <th scope="col">Fecha</th>
                                    <th scope="col">Tipo</th>
                                    <th scope="col">Titulo</th>
                                    <th scope="col">Mensaje</th>
                                    <th scope="col" className="text-center">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((e) => (
                                    <tr key={e.idNotificacion}>
                                        <td>{e.idNotificacion}</td>
                                        <td>{formatearFechaLarga(e.fecha)}</td>
                                        <td>{e.idTipoNotificacion?.tipo}</td>
                                        <td>{e.titulo && e.titulo.length > 20
                                            ? e.titulo.slice(0, 20) + "…"
                                            : e.titulo}</td>
                                        <td>
                                            {e.mensaje && e.mensaje.length > 50
                                                ? e.mensaje.slice(0, 50) + "…"
                                                : e.mensaje}
                                        </td>
                                        <td className="text-center">
                                            <div className="d-flex align-items-center gap-10 justify-content-center">
                                                <button
                                                    type="button"
                                                    className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    onClick={() => handleEdit(e)}
                                                >
                                                    <Icon icon="lucide:edit" className="menu-icon" />
                                                </button>
                                                <button
                                                    type="button"
                                                    className="bg-danger-focus text-danger-600 bg-hover-danger-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    onClick={() => handleDelete(e)}
                                                >
                                                    <Icon icon="lucide:trash" className="menu-icon" />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {renderFooter()}
                </div>
            </div>

            {/* Modal */}
            <div className="modal fade" id="exampleModal" tabIndex={-1} aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content radius-16 bg-base">
                        <div className="modal-header py-16 px-24 border-bottom">
                            <h5 className="modal-title">
                                {editingUser ? 'Editar notificación' : 'Nueva notificación'}
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>

                        <div className="modal-body p-24">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    {/* Tipo */}
                                    <div className="col-6 mb-20">
                                        <label className="form-label">Tipo *</label>
                                        <AsyncSelect
                                            required
                                            cacheOptions
                                            defaultOptions={tipoDefaultOptions}   // se llenan al abrir
                                            loadOptions={loadTipo}
                                            onMenuOpen={prefetchTipos}             // 🔎 buscar al click
                                            onChange={(opt) => setSelectedTipo(opt)}
                                            placeholder="Selecciona tipo…"
                                            value={selectedTipo}
                                            noOptionsMessage={() => "Escribe para buscar…"}
                                        />
                                    </div>

                                    {/* Trabajadores (solo si tipo = 2) */}
                                    {selectedTipo?.value === 2 && (
                                        <div className="col-12 mb-20">
                                            <label className="form-label">Trabajadores *</label>
                                            <AsyncSelect
                                                isMulti
                                                required
                                                cacheOptions
                                                defaultOptions={empleadoDefaultOptions} // se llenan al abrir
                                                loadOptions={loadEmpleados}
                                                onMenuOpen={prefetchEmpleados}          // 🔎 buscar al click
                                                onChange={(opts) => setSelectedEmpleado(opts || [])}
                                                placeholder="Buscar trabajador…"
                                                value={selectedEmpleado}
                                                noOptionsMessage={() => "Escribe para buscar…"}
                                            />
                                        </div>
                                    )}


                                    {/* Trabajadores (solo si tipo = 2) */}
                                    {selectedTipo?.value === 3 && (
                                        <div className="col-12 mb-20">
                                            <label className="form-label">Marca *</label>
                                            <AsyncSelect
                                                isMulti
                                                required
                                                cacheOptions
                                                defaultOptions={marcaDefaultOptions} // se llenan al abrir
                                                loadOptions={loadMarcas}
                                                onMenuOpen={prefetchMarcas}          // 🔎 buscar al click
                                                onChange={(opts) => setSelectedMarca(opts || [])}
                                                placeholder="Buscar marca de trabajador…"
                                                value={selectedMarca}
                                                noOptionsMessage={() => "Escribe para buscar…"}
                                            />
                                        </div>
                                    )}


                                    {/* Trabajadores (solo si tipo = 2) */}
                                    {selectedTipo?.value === 4 && (
                                        <div className="col-12 mb-20">
                                            <label className="form-label">Areas *</label>
                                            <AsyncSelect
                                                isMulti
                                                required
                                                cacheOptions
                                                defaultOptions={areaDefaultOptions} // se llenan al abrir
                                                loadOptions={loadAreas}
                                                onMenuOpen={prefetchAreas}          // 🔎 buscar al click
                                                onChange={(opts) => setSelectedArea(opts || [])}
                                                placeholder="Buscar area de trabajador…"
                                                value={selectedArea}
                                                noOptionsMessage={() => "Escribe para buscar…"}
                                            />
                                        </div>
                                    )}

                                    <div className="col-12 mb-20">
                                        <label className="form-label">Fecha *</label>
                                        <input type="date" name="fecha" required className="form-control"
                                            value={formFecha}
                                            onChange={(e) => setFormFecha(e.target.value)} />
                                    </div>

                                    <div className="col-12 mb-20">
                                        <label className="form-label">Titulo *</label>
                                        <input type="text" name="titulo" required className="form-control"
                                            value={formTitulo}
                                            onChange={(e) => setFormTitulo(e.target.value)} />
                                    </div>

                                    <div className="col-12 mb-20">
                                        <label className="form-label">Mensaje *</label>
                                        <div
                                            className="form-control p-0"
                                            style={{
                                                height: "auto",
                                                minHeight: "unset",
                                                display: "flex",
                                                flexDirection: "column"
                                            }}
                                        >
                                            <ReactQuill
                                                theme="snow"
                                                value={mensajeHtml}
                                                onChange={(val) => setMensajeHtml(val)}
                                                modules={quillModules}
                                                formats={quillFormats}
                                                placeholder="Escribe el mensaje…"
                                                style={{ flex: 1 }}
                                            />
                                        </div>
                                        {isMensajeVacio && (
                                            <small className="text-danger">El mensaje es requerido.</small>
                                        )}
                                    </div>

                                    <div className="col-12 mb-20">
                                        <label className="form-label">Enlace </label>
                                        <input type="text" name="enlace" className="form-control"
                                            value={formEnlace}
                                            onChange={(e) => setFormEnlace(e.target.value)} />
                                    </div>

                                    {getValue('s3') && (
                                        <div className="mb-3 text-center">
                                            <img
                                                src={getValue('s3')}
                                                alt=""
                                                className="img-fluid rounded"
                                                style={{ maxHeight: 280, objectFit: "cover" }}
                                                onError={(e) => (e.currentTarget.style.display = "none")}
                                            />
                                        </div>
                                    )}

                                    <div className="col-12 mb-20">
                                        <label className="form-label">Imagen </label>
                                        <input
                                            type="file"
                                            name="imagen"
                                            accept=".png,.jpeg,.jpg"
                                            onChange={handleFileChange}
                                            className="form-control" />
                                    </div>

                                </div>

                                <div className="text-center mt-24">
                                    <button type="submit" className="btn btn-primary px-48 py-12">
                                        Guardar
                                    </button>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}